import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhoFor from "./components/WhoFor";
import HowItWorks from "./components/HowItWorks";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import KvkkNotice from "./pages/KvkkNotice";
import TermsOfUse from "./pages/TermsOfUse";
import NotFound from "./pages/NotFound";

import HesapSilme from "./pages/HesapSilme";
import Support from "./pages/Support";
import IndirPage from "./pages/IndirPage";

import NakliyeFiyatlariPage from "./pages/NakliyeFiyatlari";

function Landing() {
  return (
    <>
      <Navbar />
      <Hero />
      <WhoFor />
      <HowItWorks />
      <FAQ />
      <Footer />
    </>
  );
}

function Layout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Landing */}
        <Route path="/" element={<Landing />} />

        {/* Download */}
        <Route
          path="/indir"
          element={
            
              <IndirPage />
            
          }
        />

        {/* SEO Pages */}
        <Route
          path="/nakliye-fiyatlari"
          element={
            <Layout>
              <NakliyeFiyatlariPage />
            </Layout>
          }
        />

        {/* Legal */}
        <Route
          path="/gizlilik"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />

        <Route
          path="/kvkk"
          element={
            <Layout>
              <KvkkNotice />
            </Layout>
          }
        />

        <Route
          path="/kullanim-kosullari"
          element={
            <Layout>
              <TermsOfUse />
            </Layout>
          }
        />

        {/* Support */}
        <Route
          path="/hesap-silme"
          element={
            <Layout>
              <HesapSilme />
            </Layout>
          }
        />

        <Route
          path="/destek"
          element={
            <Layout>
              <Support />
            </Layout>
          }
        />

        {/* 404 */}
        <Route
          path="*"
          element={
            <Layout>
              <NotFound />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}